<template>
    <component :is="header" />
</template>

<script>
    import MainHeader from "@/components/views/header/main-header.vue";
    import HeaderStripped from "@/components/views/header/stripped-header.vue";

    export default {
        name: "app-header",

        components: {
            "main-header": MainHeader,
            "header-stripped": HeaderStripped,
        },

        computed: {
            header() {
                return this.$route.meta.useStrippedHeader ? "header-stripped" : "main-header";
            }
        }
    };
</script>